import { UploadOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import { UploadImageId } from 'components/atoms'
import { t } from 'i18next'
import { IImageUpload } from 'interfaces'
import { useRef, useState } from 'react'
import styled from 'styled-components'
import { StyleLabel } from 'styles/styledGlobal'

const StyledUploadImage = styled(UploadImageId)`
  width: 104px;
  height: 104px;
  .ant-upload {
    height: 104px;
  }
`
interface IProps {
  title?: string
  onChange?: (ids?: Array<number>, images?: Array<IImageUpload>) => void
  max?: number
  required?: boolean
}
const UploadImages = (props: IProps) => {
  const { title, max, onChange, required } = props
  const images = useRef<Array<IImageUpload>>([])
  const [totalImage, setTotalImage] = useState(1)

  const handleOnChangeFile = (img?: IImageUpload) => {
    if (!img) return
    images.current.push(img)
    handleOnChange()
    if (max && max === totalImage) return
    setTotalImage(totalImage + 1)
  }

  const handleOnRemove = (id?: number) => {
    setTotalImage(totalImage - 1)
    images.current = images.current?.filter((img) => img.id !== id)
    handleOnChange()
  }

  const handleOnChange = () => {
    const ids = images.current?.map((img) => img.id)
    if (onChange) onChange(ids, images.current)
  }

  const renderImage = () => {
    const imagComponents = []
    for (let index = 0; index < totalImage; index++) {
      imagComponents.push(
        <Col key={index}>
          <StyledUploadImage
            title=""
            buttonUpload={<UploadOutlined />}
            onRemove={handleOnRemove}
            onChange={(url, img) => handleOnChangeFile(img)}
          />
        </Col>
      )
    }
    return imagComponents
  }

  return (
    <>
      <StyleLabel $required={required} className="upload-image-title">
        {t(title || '')}
      </StyleLabel>
      <Row gutter={16}>{renderImage()}</Row>
    </>
  )
}

export default UploadImages
